export default "__VITE_ASSET__WwYhPEWf__"